import axios from 'axios';

// API 베이스 URL 설정
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// API 함수들
export const getDashboardStats = async () => {
  const response = await api.get('/api/dashboard/stats');
  return response.data;
};

export const getDashboardHistory = async () => {
  const response = await api.get('/api/dashboard/history');
  return response.data;
};

export const getDashboardDistribution = async () => {
  const response = await api.get('/api/dashboard/distribution');
  return response.data;
};

export const getModelStatus = async () => {
  const response = await api.get('/api/model/status');
  return response.data;
};

export const predictColor = async (l, a, b, target = 'season') => {
  const response = await api.post('/api/predict', { l, a, b, target });
  return response.data;
};

export const testPredict = async (l, a, b) => {
  const response = await api.post('/api/test/predict', { l, a, b });
  return response.data;
};

export const triggerRetrain = async () => {
  const response = await api.post('/api/admin/retrain');
  return response.data;
};

export default api;
